// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2x7AO","actionsCol":"EnrolledClinics_actionsCol__ClVrz"};